<mat-dialog-content class="mat-typography">
	<p>
		Se esta opção for selecionada, somente os usuários<br />
		que possuem todas as condições selecionadas<br />
		receberão este conteúdo.
	</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button class="btn btn-primary ms-2 d-flex align-items-center" [mat-dialog-close]="true">Ok</button>
</mat-dialog-actions>
